import { render, staticRenderFns } from "./swipeImg.vue?vue&type=template&id=e6e54d2c&scoped=true"
import script from "./swipeImg.vue?vue&type=script&lang=js"
export * from "./swipeImg.vue?vue&type=script&lang=js"
import style0 from "./swipeImg.vue?vue&type=style&index=0&id=e6e54d2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e54d2c",
  null
  
)

export default component.exports